import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const MobiControl = ({ blocks, context, openJSEditor }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} openJSEditor={openJSEditor} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='MobiControl' id='mobicontrol' iconclass='category with-icon-paths snap-icon-SOTI_Mobicontrol'>{/* NOSONAR */}
                <label text="MobiControl"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

MobiControl.propTypes = {
    context: PropTypes.object,
    blocks: PropTypes.object,
    openJSEditor: PropTypes.func
};

export default MobiControl;